function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModernArchitecture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 61 59",
    style: {
      enableBackground: "new 0 0 61 59"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x35_-Modern_House"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECEAEC"
    },
    points: "3,41 3,59 19.104,59 35,59 35,32.163  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECEAEC"
    },
    points: "55.001,26 48,27.711 48,59 58,59 58,25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D3D3D3"
    },
    points: "34,32 34,59 49,59 49,53.213 49,27.724  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECEAEC"
    },
    points: "37,28.079 6,18 6,38  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91979B"
    },
    d: "M10,44v8.619c0.182-0.017,0.365-0.033,0.552-0.033c1.91,0,3.588,0.867,4.559,3.207   c0.282-0.132,0.574-0.224,0.883-0.224c1.718,0,3.11,0.732,3.11,3.431H29V44H10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB6BB"
    },
    d: "M15.034,44v11.638c0.024,0.054,0.053,0.099,0.076,0.155c0.282-0.132,0.574-0.224,0.883-0.224   c1.718,0,3.11,0.732,3.11,3.431H24V44H15.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#46AB6F"
    },
    d: "M15.994,55.569c-0.309,0-0.602,0.093-0.883,0.224c-0.971-2.34-2.648-3.207-4.559-3.207   s-3.588,0.867-4.559,3.207c-0.282-0.132-0.574-0.224-0.883-0.224C3.392,55.569,2,56.301,2,59h17.103   C19.103,56.301,17.711,55.569,15.994,55.569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#46AB6F"
    },
    d: "M56.89,55.569c-0.309,0-0.602,0.093-0.883,0.224c-0.971-2.34-2.648-3.207-4.559-3.207   s-3.588,0.867-4.559,3.207c-0.282-0.132-0.574-0.224-0.883-0.224c-1.717,0-3.11,0.732-3.11,3.431H60   C60,56.301,58.608,55.569,56.89,55.569z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 25,
    style: {
      fill: "#7383BF"
    },
    width: 6,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 33,
    style: {
      fill: "#7383BF"
    },
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 43,
    style: {
      fill: "#7383BF"
    },
    width: 5,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91979B"
    },
    d: "M45,55.683V44h-6v15h3.896C42.896,56.858,43.779,55.965,45,55.683z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#605663"
    },
    points: "47.378,27 2,14 2,18.379 40,29.175  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M55,7c-0.552,0-1-0.448-1-1c0-1.103-0.897-2-2-2c-0.552,0-1-0.448-1-1s0.448-1,1-1   c1.064,0,2.032,0.418,2.75,1.098C55.774,1.252,57.744,0,60,0c0.552,0,1,0.448,1,1s-0.448,1-1,1c-2.206,0-4,1.794-4,4   C56,6.552,55.552,7,55,7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#736A76"
    },
    points: "0,42.966 0,38.69 60,21 60,25.862  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB6BB"
    },
    d: "M33.816,10L29,7c0-0.642-4.794-1.234-4.451-1.722c-1.252,0.489-2.199,1.585-2.469,2.931   C21.744,8.078,21.382,8,21,8c-1.657,0-3,1.343-3,3s1.343,3,3,3h10c1.657,0,3-1.343,3-3C34,10.647,33.928,10.314,33.816,10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7ECED"
    },
    d: "M37,4c-0.382,0-0.744,0.078-1.08,0.208C35.553,2.379,33.938,1,32,1s-3.553,1.379-3.92,3.208   C27.744,4.078,27.382,4,27,4c-1.657,0-3,1.343-3,3s1.343,3,3,3h10c1.657,0,3-1.343,3-3S38.657,4,37,4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModernArchitecture);
export default __webpack_public_path__ + "static/media/modern-architecture.0eb162f38fd922d96817099f5320e881.svg";
export { ForwardRef as ReactComponent };